import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ListUsersPage from './list';
import EditUserPage from './edit';

const UsersRoutingPages = ({ match }) => (
  <Suspense fallback={<div className="loading" />}>
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />

        <Route path={`${match.url}/list`}
          render={props => <ListUsersPage {...props} />}
        />

        <Route path={`${match.url}/edit/:userId`}
          render={props => <EditUserPage {...props} />}
        />

        <Redirect from={`${match.url}/`} to={`${match.url}/list`} />
        <Redirect to="/error" />
      </Switch>
    
  </Suspense>
);
export default UsersRoutingPages;
